import type { Action } from "../../actions/types";

export type ShopifyVariantRecord = {
  id: string;
  title: string;
  sku: string;
  price: string;
  compareAtPrice: string | null;
  inventoryQuantity: number;
  inventoryPolicy: string;
  product: {
    id: string;
    title: string;
    featuredImage: { url: string };
  };
};

export type StoreState = {
  count: number;
  records: ShopifyVariantRecord[];
};

export const initialState = {
  count: 0,
  records: [],
};

export function reducer(
  state: StoreState = initialState,
  action: Action
): StoreState {
  switch (action.type) {
    case "GET_SHOPIFY_VARIANTS_SUCCESS": {
      const records = action.response.data.variants || [];

      return {
        ...state,
        count: records.length,
        records,
      };
    }

    default:
      return state;
  }
}
